
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/work-management/features",
      function () {
        return require("private-next-pages/work-management/features/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/work-management/features"])
      });
    }
  